import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const BIN_ID = "690c6a6bae596e708f4805cb"; 
const MASTER_KEY = "$2a$10$vFa4BtnB1Nu1BUL6ukKdC.lLtW5/vwurJX3qGqj0CTcem.7tuWqyW"; 

function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`https://api.jsonbin.io/v3/b/${BIN_ID}/latest`, {
        method: "GET",
        headers: {
          "X-Master-Key": MASTER_KEY,
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();
      const users = data.record || [];
      const userFound = users.find(
        (u) => u.email === email && u.password === password
      );

      if (userFound) {
        alert("✅ Login successful!");
        navigate("/usermanager");
      } else {
        alert("❌ Invalid Email or Password!");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      alert("⚠ Unable to connect. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-r from-blue-100 via-white to-blue-100">
      <div className="bg-white shadow-2xl rounded-2xl p-8 w-96 border border-gray-200">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          🔐 Login
        </h2>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />

          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />

          {/* Login Button */}
          <button
            type="submit"
            onClick={() => navigate("/main")}
            className="w-full bg-green-500 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-green-600 transition-all disabled:bg-gray-400"
          >
            {loading ? "Checking..." : "Login"}
          </button>

          {/* Register Button */}
          <button
            type="button"
            onClick={() => navigate("/register")}
            className="w-full bg-blue-500 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-blue-600 transition-all"
          >
            Go to Register
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;